import { defineType } from "sanity";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "raqCTA",
  type: "object",
  title: "RAQ CTA",
  fields: [
    {
      name: "label",
      type: "multilingualArrayString",
      description: 'leave empty for "Request a Quote"'
    },
    {
      name: "cruise",
      title: "Cruise",
      type: "reference",
      to: [{ type: "cruise" }, { type: "specialVoyage" }]
    },
    {
      name: "type",
      type: "buttonType"
    }
  ],
  preview: {
    select: {
      title: "label"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "Request a Quote"
      };
    }
  }
});
